import type { SpotBidExpireTimeOptionsApi } from '../../models';

export const normalizeSpotBidExpirationTimeOptions = (list: SpotBidExpireTimeOptionsApi) => {
  if (!list?.listTimerange) {
    return [];
  }

  return list.listTimerange.map((option) => ({
    label: option.text,
    value: option.value,
  }));
};
